import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=6c2909ef&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=6c2909ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2909ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2909ef')) {
      api.createRecord('6c2909ef', component.options)
    } else {
      api.reload('6c2909ef', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=6c2909ef&scoped=true&", function () {
      api.rerender('6c2909ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dLm6smQxWhd8/JS/comp/DocBox.vue"
export default component.exports